import { FC } from 'react'

import {
  ApproversField,
  ConfigFormTemplate,
  InputSelectControlField,
  useApprovers
} from 'Automations/nodeDefinitions/components'
import { ConfigFormProps } from 'Automations/nodeDefinitions/types'
import { useNode } from 'Automations/nodeDefinitions/hooks'
import { reviewTypeLabel, reviewTypeTargetDefinition } from '..'
import { Config } from '.'

export const ReviewQuoteConfigForm: FC<ConfigFormProps> = ({ nodeId }) => {
  const {
    nodeData,
    setNodeData,
    updateNodeType,
    definition,
    validationErrors
  } = useNode<Config>({ nodeId })

  const {
    userOptions,
    approvers,
    isPending: isUsersPending,
    multiSelectKey,
    removeApprover
  } = useApprovers({
    approverUserIds: nodeData?.approverUserIds ?? [],
    onChange: ids => setNodeData('approverUserIds', ids)
  })

  if (!nodeData || !definition) return null

  return (
    <ConfigFormTemplate>
      <ConfigFormTemplate.Header nodeId={nodeId} />

      <ConfigFormTemplate.Row label="Review">
        <InputSelectControlField
          data-testid="automations.editor.configForm.review.reviewType"
          value={nodeData.reviewType}
          placeholder="Select type..."
          options={Object.entries(reviewTypeLabel).map(([value, label]) => ({
            value,
            label
          }))}
          onChange={reviewType => {
            updateNodeType(
              reviewTypeTargetDefinition[reviewType as Config['reviewType']],
              { approverUserIds: nodeData?.approverUserIds ?? [] }
            )
          }}
          validationErrors={validationErrors.reviewType}
        />
      </ConfigFormTemplate.Row>

      <ApproversField
        testIdPrefix="automations.editor.configForm.review"
        approvers={approvers}
        onRemoveApprover={removeApprover}
        userOptions={userOptions}
        approverUserIds={nodeData.approverUserIds}
        isUsersPending={isUsersPending}
        multiSelectKey={multiSelectKey}
        onApproversChange={userIds => setNodeData('approverUserIds', userIds)}
        validationErrors={validationErrors.approverUserIds}
      />
    </ConfigFormTemplate>
  )
}
